import React from 'react'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { setInitialState } from '../../../store/home-page-items/reducer'
import { useAppHeaderLogoStyles } from './app-header-logo.styles'

export const AppHeaderLogo: React.FC = (): React.ReactElement => {
  const classes = useAppHeaderLogoStyles()
  const dispatch = useDispatch()

  /**
   * Handles logo click event and resets home page items settings
   */
  const onClickHandler = () => {
    dispatch(setInitialState())
  }

  return (
    <Link to="/" className={classes.root} onClick={onClickHandler}>
      <img src="/images/logo-white.svg" className={classes.logo} alt="" />
      <img src="/images/logo-mini.svg" className={classes.logoMini} alt="" />
    </Link>
  )
}
